import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

// Εικονίδια SVG
const PhoneIcon = (
  <svg width="56" height="56" fill="none" viewBox="0 0 24 24"><path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
);
const EmailIcon = (
  <svg width="56" height="56" fill="none" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2" stroke="#38bdf8" strokeWidth="2"/><path d="M3 7l9 6 9-6" stroke="#38bdf8" strokeWidth="2"/></svg>
);

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle');
  const { t } = useLanguage();

  // Formspree endpoint (θα το αλλάξεις με το δικό σου αν κάνεις register)
  const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xayrvwqg'; // placeholder, άλλαξέ το με το δικό σου!

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('loading');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          message: form.message,
        }),
      });
      if (res.ok) {
        setStatus('success');
        setForm({ name: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const isMobile = window.innerWidth < 640;

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + '/contact.jpg'})`,
        fontFamily: 'Montserrat, Poppins, Inter, sans-serif',
      }}
    >
      <div className="flex flex-col sm:flex-row gap-8 w-full max-w-3xl mx-auto px-2 sm:px-4" style={{maxWidth: '100vw', overflowX: 'hidden'}}>
        {isMobile ? (
          <>
            <div className="w-full mb-6">
              {/* Contact Form */}
              <div className="backdrop-blur-md bg-white/70 border border-white/40 rounded-3xl shadow-2xl flex flex-col items-center justify-center px-4 sm:px-8 md:px-16 py-8 sm:py-12 md:py-16 min-h-[320px] sm:min-h-[400px] md:min-h-[480px] w-full md:w-[500px] lg:w-[700px] xl:w-[900px] mx-auto mt-8 md:mt-12 order-1 md:order-none" style={{maxWidth: '100vw', overflowX: 'hidden'}}>
                <h2 className="text-2xl sm:text-4xl md:text-5xl font-extrabold text-[#1e293b] mb-6 sm:mb-10 text-left w-full tracking-wide" style={{letterSpacing: '0.04em', fontFamily: 'Arial, Helvetica, Segoe UI, sans-serif'}}>{t('contact.title')}</h2>
                <form className="w-full flex flex-col gap-4 sm:gap-6 md:gap-8" onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="name"
                    placeholder={t('contact.namePlaceholder')}
                    value={form.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 sm:px-6 py-3 sm:py-5 rounded-2xl bg-white/90 border border-blue-200 text-base sm:text-xl md:text-2xl font-medium focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all shadow"
                    style={{fontFamily: 'Montserrat, Poppins, Inter, sans-serif'}}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder={t('contact.emailPlaceholder')}
                    value={form.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 sm:px-6 py-3 sm:py-5 rounded-2xl bg-white/90 border border-blue-200 text-base sm:text-xl md:text-2xl font-medium focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all shadow"
                    style={{fontFamily: 'Montserrat, Poppins, Inter, sans-serif'}}
                  />
                  <textarea
                    name="message"
                    placeholder={t('contact.messagePlaceholder')}
                    value={form.message}
                    onChange={handleChange}
                    required
                    rows={4}
                    className="w-full px-4 sm:px-6 py-3 sm:py-5 rounded-2xl bg-white/90 border border-blue-200 text-base sm:text-xl md:text-2xl font-medium focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all shadow resize-none"
                    style={{fontFamily: 'Montserrat, Poppins, Inter, sans-serif'}}
                  />
                  <button
                    type="submit"
                    className="w-full mt-2 px-6 sm:px-10 py-3 sm:py-5 bg-[#393e46] text-white font-extrabold rounded-2xl shadow-lg hover:bg-[#1e293b] transition text-base sm:text-xl md:text-2xl border border-[#393e46] tracking-wide"
                    disabled={status === 'loading'}
                    style={{fontFamily: 'Montserrat, Poppins, Inter, sans-serif'}}
                  >
                    {status === 'loading' ? t('contact.sending') : t('contact.submit')}
                  </button>
                  {status === 'success' && <div className="text-green-600 font-semibold text-center mt-2 text-base sm:text-lg md:text-xl">{t('contact.success')}</div>}
                  {status === 'error' && <div className="text-red-600 font-semibold text-center mt-2 text-base sm:text-lg md:text-xl">{t('contact.error')}</div>}
                </form>
              </div>
            </div>
            <div className="w-full">
              {/* Contact Info (κινητό, email) */}
              <div className="flex flex-col sm:flex-row md:flex-col bg-transparent md:w-1/2 w-full md:max-w-lg gap-4 sm:gap-8 md:gap-8 justify-center items-center order-2 md:order-none" style={{maxWidth: '100vw', overflowX: 'hidden'}}>
                {/* Phone */}
                <div className="backdrop-blur-md bg-white/60 border border-white/40 rounded-3xl shadow-2xl p-6 sm:p-10 md:p-12 flex flex-col items-center w-full max-w-md min-h-[160px] sm:min-h-[180px] md:min-h-[220px] transition-all hover:scale-105 hover:bg-white/80">
                  {PhoneIcon}
                  <span className="font-extrabold text-lg sm:text-xl md:text-2xl mt-4 mb-2 tracking-wide text-gray-800">{t('contact.phone')}</span>
                  <a href="tel:+306983446269" className="text-sky-600 hover:underline text-base sm:text-lg md:text-xl font-semibold tracking-wide">+30 6983446269</a>
                </div>
                {/* Email */}
                <div className="backdrop-blur-md bg-white/60 border border-white/40 rounded-3xl shadow-2xl p-6 sm:p-10 md:p-12 flex flex-col items-center w-full max-w-md min-h-[160px] sm:min-h-[180px] md:min-h-[220px] transition-all hover:scale-105 hover:bg-white/80">
                  {EmailIcon}
                  <span className="font-extrabold text-lg sm:text-xl md:text-2xl mt-4 mb-2 tracking-wide text-gray-800">{t('contact.email')}</span>
                  <a href="https://mail.google.com/mail/?view=cm&fs=1&to=eleniliapake@gmail.com" target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:underline text-base sm:text-lg md:text-xl font-semibold tracking-wide">eleniliapake@gmail.com</a>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="w-2/3">
              {/* Contact Form */}
              <div className="backdrop-blur-md bg-white/70 border border-white/40 rounded-3xl shadow-2xl flex flex-col items-center justify-center px-4 sm:px-8 md:px-16 py-8 sm:py-12 md:py-16 min-h-[320px] sm:min-h-[400px] md:min-h-[480px] w-full md:w-[500px] lg:w-[700px] xl:w-[900px] mx-auto mt-8 md:mt-12 order-1 md:order-none" style={{maxWidth: '100vw', overflowX: 'hidden'}}>
                <h2 className="text-2xl sm:text-4xl md:text-5xl font-extrabold text-[#1e293b] mb-6 sm:mb-10 text-left w-full tracking-wide" style={{letterSpacing: '0.04em', fontFamily: 'Arial, Helvetica, Segoe UI, sans-serif'}}>{t('contact.title')}</h2>
                <form className="w-full flex flex-col gap-4 sm:gap-6 md:gap-8" onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="name"
                    placeholder={t('contact.namePlaceholder')}
                    value={form.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 sm:px-6 py-3 sm:py-5 rounded-2xl bg-white/90 border border-blue-200 text-base sm:text-xl md:text-2xl font-medium focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all shadow"
                    style={{fontFamily: 'Montserrat, Poppins, Inter, sans-serif'}}
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder={t('contact.emailPlaceholder')}
                    value={form.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 sm:px-6 py-3 sm:py-5 rounded-2xl bg-white/90 border border-blue-200 text-base sm:text-xl md:text-2xl font-medium focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all shadow"
                    style={{fontFamily: 'Montserrat, Poppins, Inter, sans-serif'}}
                  />
                  <textarea
                    name="message"
                    placeholder={t('contact.messagePlaceholder')}
                    value={form.message}
                    onChange={handleChange}
                    required
                    rows={4}
                    className="w-full px-4 sm:px-6 py-3 sm:py-5 rounded-2xl bg-white/90 border border-blue-200 text-base sm:text-xl md:text-2xl font-medium focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all shadow resize-none"
                    style={{fontFamily: 'Montserrat, Poppins, Inter, sans-serif'}}
                  />
                  <button
                    type="submit"
                    className="w-full mt-2 px-6 sm:px-10 py-3 sm:py-5 bg-[#393e46] text-white font-extrabold rounded-2xl shadow-lg hover:bg-[#1e293b] transition text-base sm:text-xl md:text-2xl border border-[#393e46] tracking-wide"
                    disabled={status === 'loading'}
                    style={{fontFamily: 'Montserrat, Poppins, Inter, sans-serif'}}
                  >
                    {status === 'loading' ? t('contact.sending') : t('contact.submit')}
                  </button>
                  {status === 'success' && <div className="text-green-600 font-semibold text-center mt-2 text-base sm:text-lg md:text-xl">{t('contact.success')}</div>}
                  {status === 'error' && <div className="text-red-600 font-semibold text-center mt-2 text-base sm:text-lg md:text-xl">{t('contact.error')}</div>}
                </form>
              </div>
            </div>
            <div className="w-1/3">
              {/* Contact Info (κινητό, email) */}
              <div className="flex flex-col sm:flex-row md:flex-col bg-transparent md:w-1/2 w-full md:max-w-lg gap-4 sm:gap-8 md:gap-8 justify-center items-center order-2 md:order-none" style={{maxWidth: '100vw', overflowX: 'hidden'}}>
                {/* Phone */}
                <div className="backdrop-blur-md bg-white/60 border border-white/40 rounded-3xl shadow-2xl p-6 sm:p-10 md:p-12 flex flex-col items-center w-full max-w-md min-h-[160px] sm:min-h-[180px] md:min-h-[220px] transition-all hover:scale-105 hover:bg-white/80">
                  {PhoneIcon}
                  <span className="font-extrabold text-lg sm:text-xl md:text-2xl mt-4 mb-2 tracking-wide text-gray-800">{t('contact.phone')}</span>
                  <a href="tel:+306983446269" className="text-sky-600 hover:underline text-base sm:text-lg md:text-xl font-semibold tracking-wide">+30 6983446269</a>
                </div>
                {/* Email */}
                <div className="backdrop-blur-md bg-white/60 border border-white/40 rounded-3xl shadow-2xl p-6 sm:p-10 md:p-12 flex flex-col items-center w-full max-w-md min-h-[160px] sm:min-h-[180px] md:min-h-[220px] transition-all hover:scale-105 hover:bg-white/80">
                  {EmailIcon}
                  <span className="font-extrabold text-lg sm:text-xl md:text-2xl mt-4 mb-2 tracking-wide text-gray-800">{t('contact.email')}</span>
                  <a href="https://mail.google.com/mail/?view=cm&fs=1&to=eleniliapake@gmail.com" target="_blank" rel="noopener noreferrer" className="text-sky-600 hover:underline text-base sm:text-lg md:text-xl font-semibold tracking-wide">eleniliapake@gmail.com</a>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
} 